import React from 'react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import './Cart.css';

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, subtotal, deliveryCharge, total } = useCart();
  const navigate = useNavigate();

  if (cartItems.length === 0) {
    return (
      <div className="cart__empty">
        <h2>Your cart is empty</h2>
        <button onClick={() => navigate('/')}>Browse Soaps</button>
      </div>
    );
  }

  return (
    <div className="cart">
      <h1>Your Cart</h1>
      <div className="cart__layout">
        <div className="cart__items">
          {cartItems.map((item) => (
            <div className="cart__item" key={item.id}>
              <img src={item.images[0]} alt={item.name} className="cart__item-img" />
              <div className="cart__item-info">
                <h3>{item.name}</h3>
                <p>₹{item.price} per bar</p>
                <div className="cart__item-qty">
                  <button onClick={() => {
                    if (item.quantity === 1) {
                      removeFromCart(item.id);
                    } else {
                      updateQuantity(item.id, item.quantity - 1);
                    }
                  }}>−</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                </div>
              </div>
              <div className="cart__item-right">
                <p className="cart__item-total">₹{item.price * item.quantity}</p>
                <button className="cart__item-remove" onClick={() => removeFromCart(item.id)}>Remove</button>
              </div>
            </div>
          ))}
        </div>

        <div className="cart__summary">
          <h2>Order Summary</h2>
          <div className="cart__summary-row">
            <span>Subtotal</span>
            <span>₹{subtotal}</span>
          </div>
          <div className="cart__summary-row">
            <span>Delivery</span>
            <span>{deliveryCharge === 0 ? 'Free' : `₹${deliveryCharge}`}</span>
          </div>
          {deliveryCharge === 100 && (
            <p className="cart__free-delivery-hint">Add ₹{500 - subtotal} more for free delivery</p>
          )}
          <div className="cart__summary-row cart__summary-total">
            <span>Total</span>
            <span>₹{total}</span>
          </div>
          <button className="cart__checkout-btn" onClick={() => navigate('/checkout')}>
            Proceed to Checkout
          </button>
          <button className="cart__continue-btn" onClick={() => navigate('/')}>
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cart;